import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_TACHOGRAPH_COMPANY_CARD } from "@/constants/resultsLimits";

/**
 * All company cards registered in the database. Asking only for the ones valid right now hides
 * expired cards, and an expired company card is exactly what the user needs to see.
 *
 * `isTruncated` is true when a page as long as the requested limit came back, so more cards may
 * exist than were returned.
 */
export function useTachographCompanyCards() {
  const { geotabClient, activeSessionId } = useGeotabClient();

  const query = useQuery({
    queryKey: ["tachographCompanyCards", activeSessionId],

    queryFn: ({ signal }) =>
      geotabClient.get("TachographCompanyCard", {}, RESULTS_LIMIT_TACHOGRAPH_COMPANY_CARD, signal),
  });

  // Object.assign keeps TanStack's tracked result: a spread would read every field and re-render
  // the caller on each fetch-state change.
  return Object.assign(query, {
    isTruncated: (query.data?.length ?? 0) >= RESULTS_LIMIT_TACHOGRAPH_COMPANY_CARD,
  });
}
